﻿import { useTranslation } from "react-i18next";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import Breadcrumb from "./components/Breadcrumb";
import Hero from "./components/Hero";
import ArticleGrid from "./components/ArticleGrid";

export default function BlogHubPage() {
  const { t } = useTranslation("blog");

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: t("schema.blogName"),
    description: t("schema.blogDescription"),
    url: "https://ramen-repair-eindhoven.nl/blog/",
    publisher: {
      "@type": "LocalBusiness",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: "https://ramen-repair-eindhoven.nl/blog/",
      },
    ],
  };

  return (
    <>
      <title>{t("meta.title")}</title>
      <meta name="description" content={t("meta.description")} />
      <meta property="og:title" content={t("meta.title")} />
      <meta property="og:description" content={t("meta.description")} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/blog/" />
      <meta property="og:image" content="/og/og-blog.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie blog" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/blog/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/blog/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/blog/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t("meta.title")} />
      <meta name="twitter:description" content={t("meta.description")} />
      <meta name="twitter:image" content="/og/og-blog.jpg" />
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>

      <Header />
      <main>
        <Breadcrumb />
        <Hero />
        <ArticleGrid />
      </main>
      <Footer />
    </>
  );
}